// src/features/records/services/attachments/mutations.js

import { auth, db, functions } from '../../../../firebase';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { requireUser } from '../utils/auth';
import { deleteAttachmentCacheEntry } from './state';

const deleteAttachmentsFn = httpsCallable(functions, 'deleteAttachments');

/**
 * Create a new attachment document in the subcollection.
 */
export async function createAttachment(recordId, attachmentId, attachmentData) {
  requireUser();

  if (!attachmentId) {
    throw new Error('Attachment ID is required');
  }

  if (attachmentData.storagePath && !attachmentData.storagePath.includes(attachmentId)) {
    throw new Error(`Storage path must contain attachment ID. Expected ID: ${attachmentId}, Path: ${attachmentData.storagePath}`);
  }

  try {
    const attachment = {
      ...attachmentData,
      recordId: recordId,
      uploadedAt: serverTimestamp(),
      uploadedBy: auth.currentUser.uid,
      thumbnails: attachmentData.thumbnails || {}
    };

    const docRef = doc(db, 'records', recordId, 'attachments', attachmentId);
    await setDoc(docRef, attachment);

    const createdAttachment = {
      id: attachmentId,
      ...attachment,
      uploadedAt: new Date()
    };

    deleteAttachmentCacheEntry(recordId);

    return createdAttachment;
  } catch (error) {
    console.error('Error creating attachment:', error);
    throw error;
  }
}

/**
 * Delete multiple attachments with Storage cleanup.
 */
export async function deleteAttachments(recordId, attachmentIds) {
  requireUser();

  if (!attachmentIds || attachmentIds.length === 0) {
    return { success: [], failed: [] };
  }

  try {
    const result = await deleteAttachmentsFn({
      recordId,
      attachmentIds
    });

    deleteAttachmentCacheEntry(recordId);

    return result.data;
  } catch (error) {
    console.error('Error deleting attachments:', error);

    return {
      success: [],
      failed: attachmentIds.map((id) => ({ attachmentId: id, error: error.message }))
    };
  }
}
